import { route } from '@/utils/build'
const component = path => resolve => require(['@/pages/payment/views/' + path], resolve)

/**
 * 直播
 */
export default [
  //
  route('/live', 'live', component('baijiayun/index'))
]
